import { StandardEvents } from '@shopify/events';

// Restore the server-rendered grid when Back/Forward revisits a filter URL.
let currentSearch = window.location.search;
document.addEventListener(StandardEvents.collectionUpdate, () => {
  currentSearch = window.location.search;
});
window.addEventListener('popstate', () => {
  if (window.location.search !== currentSearch) window.location.reload();
});

// Shopify alternate views supply real server-side page sizes. Keep the complete
// current query (including repeated filters and preview context), reset page only.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-sotp-page-size]')) return;
  const view = new FormData(form).get('view');
  if (!['', 'sotp-15', 'sotp-50'].includes(view)) return;
  event.preventDefault();
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  url.searchParams.delete('section_id');
  if (view) url.searchParams.set('view', view);
  else url.searchParams.delete('view');
  url.hash = 'ResultsList';
  window.location.assign(url.href);
});
